import { JSX, ReactNode } from 'react';
import { SkeletonPulse } from '@bg-components/Skeleton';
import classes from './ReportSkeleton.module.scss';

interface IProps {
    filtersCount?: number;
    rowsCount?: number;
    showHeader?: boolean;
}

export const ReportSkeleton = ({
    filtersCount = 1,
    rowsCount = 30,
    showHeader = true,
}: IProps): JSX.Element => {
    const renderDetails = (): ReactNode => (
        <>
            <SkeletonPulse className={classes.entity} radius="15px" width="9%" height="20px" />
            <SkeletonPulse className={classes.entity} radius="15px" width="60%" height="20px" />
            <SkeletonPulse className={classes.entity} radius="15px" width="5%" height="20px" />
        </>
    );

    return (
        <section className={classes.container}>
            {showHeader && (
                <header className={classes.header}>
                    <SkeletonPulse width="120px" height="30px" radius="15px" />
                    <div className={classes.filters}>
                        {Array(filtersCount)
                            .fill(null)
                            .map((_, index) => (
                                <SkeletonPulse key={index} className={classes.filter} />
                            ))}
                    </div>
                </header>
            )}
            <div className={classes.list}>
                {Array(rowsCount)
                    .fill(null)
                    .map((_, index) => (
                        <div key={index} className={classes.listItem}>
                            <SkeletonPulse
                                className={classes.entity}
                                radius="15px"
                                width="25%"
                                height="20px"
                            />
                            <SkeletonPulse
                                className={classes.entity}
                                radius="5px"
                                width="30%"
                                height="40px"
                            />
                            <div className={classes.details}>{renderDetails()}</div>
                        </div>
                    ))}
            </div>
        </section>
    );
};
